import { Badge, type BadgeProps, type MantineColor } from '@mantine/core';

import { EmployeeAlertPriority } from '@/common/graphql';
import { EmployeeAlertPriorityLabels } from '@/common/types';

const getStatusColor = (status: EmployeeAlertPriority): MantineColor => {
  switch (status) {
    case EmployeeAlertPriority.High:
      return 'red';
    case EmployeeAlertPriority.Medium:
      return 'yellow';
    case EmployeeAlertPriority.Low:
      return 'teal';
  }
};

interface Props extends BadgeProps {
  priority?: EmployeeAlertPriority;
}

export const EmployeeAlertPriorityBadge = ({ priority, ...rest }: Props) => {
  if (!priority) {
    return null;
  }

  return (
    <Badge {...rest} color={getStatusColor(priority)}>
      {EmployeeAlertPriorityLabels[priority]}
    </Badge>
  );
};
